var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74874 2.98633C6.43363 1.67122 4.30143 1.67122 2.98633 2.98633C1.67122 4.30143 1.67122 6.43363 2.98633 7.74874L4.53048 9.2929C4.92101 9.6834 4.92101 10.3166 4.53048 10.7071C4.13996 11.0976 3.50679 11.0976 3.11627 10.7071L1.57211 9.163C-0.524037 7.0668 -0.524037 3.66827 1.57211 1.57211C3.66827 -0.524037 7.0668 -0.524037 9.163 1.57211L18.4279 10.837C20.524 12.9332 20.524 16.3317 18.4279 18.4279C16.3317 20.524 12.9332 20.524 10.837 18.4279L7.3627 14.9535C5.90616 13.497 5.90616 11.1355 7.3627 9.6789C8.8192 8.2224 11.1808 8.2224 12.6373 9.6789L14.5675 11.6091C14.958 11.9997 14.958 12.6328 14.5675 13.0233C14.177 13.4139 13.5438 13.4139 13.1533 13.0233L11.2231 11.0931C10.5476 10.4177 9.4524 10.4177 8.7769 11.0931C8.1014 11.7686 8.1014 12.8638 8.7769 13.5393L12.2513 17.0137C13.5664 18.3288 15.6986 18.3288 17.0137 17.0137C18.3288 15.6986 18.3288 13.5664 17.0137 12.2513L7.74874 2.98633Z",
    fill: "#475467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.fb78d4e9b882ba437cbb4d7905af8262.svg";
export { ForwardRef as ReactComponent };